import { InviteCode } from "../../common/types/inviteCode";
import { validateCancelInvite } from "../../common/helpers/workspacePermissions";
import { useCurrentUserWorkspaceMember } from "./useCurrentUserWorkspaceMember";

export function useCanCancelInvite(invite: InviteCode) {
    const currentMember = useCurrentUserWorkspaceMember();

    return Boolean(
        currentMember && !validateCancelInvite(currentMember, invite),
    );
}
